import script from "./ParameterConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./ParameterConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./ParameterConfiguration.vue?vue&type=style&index=0&id=85335ed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85335ed2"]])

export default __exports__